// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@/helpers/filters";

import { createApp } from "vue";
import VueScrollTo from "vue-scrollto"; // Import vue-scrollto

import App from "./App";
import router from "./router";
import store from "./store";

const app = createApp(App);

app.config.productionTip = false;

app.use(store);
app.use(router);
app.use(VueScrollTo); // Use vue-scrollto as a plugin

store.dispatch("setInitialSignInState");

app.mount("#app");

export default app;
